<template>
    <div class="container">
        <div class="row">
            <heading>
                {{ $t('currencies.menuName') }}
            </heading>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <button class="btn btn-primary float-right ml-3" @click="store">{{ $t('core.actions.save') }}</button>
                                <button class="btn btn-primary float-right" @click="addCurrency">{{ $t('core.actions.add') }}</button>
                            </div>
                        </div>
                        <hr/>
                        <div class="row mt-3" v-for="(currency, index) in currencies">
                            <div class="col-2 offset-5">
                                <input type="text" class="form-control" v-model="currency.currency_code" :placeholder="$t('currencies.fields.currency_code')">
                            </div>
                            <div class="col-5">
                                <button class="btn btn-outline-danger" @click="currencies.splice(index, 1)">{{ $t('core.actions.remove') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { cloneDeep } from 'lodash'

const emptyCurrency = {
    id: null,
    currency_code: '',
}
export default {
    name: 'CurrenciesCreadit',
    data: () => {
        return {
            currencies: lgt.currencies,
        }
    },
    methods: {
        addCurrency(){
            this.currencies.push(cloneDeep(emptyCurrency))
        },
        store () {
            axios.post('/currency', {currencies: this.currencies}).then((response) => {
                window.location.href = '/currency?success'
            }).catch((err) => {
                this.errors = err.response.data.errors
            })
        },
    },
}
</script>
